import ReactSelectAdaptive from 'hb-react/shared/components/ReactSelect/ReactSelectAdaptive';
import { type GetTopicsResponse } from 'hb-react/shared/components/ReactSelect/ReactSelectTopics/requests';
import { getTopicsOptions } from 'hb-react/shared/components/ReactSelect/ReactSelectTopics/requests';
import { type ReactSelectTopicsProps } from 'hb-react/shared/components/ReactSelect/ReactSelectTopics/types';
import { topicsToOptions } from 'hb-react/shared/components/ReactSelect/ReactSelectTopics/utils/topicsToOptions';

const extractData = (response: GetTopicsResponse) => response.data;
const shouldUseAsync = (defaultOptionsQueryResponse: GetTopicsResponse) =>
  defaultOptionsQueryResponse.hasNextPage;

/**
 * NOTE: this component uses a backoffice endpoint to fetch topics
 */
const ReactSelectTopics = ({
  isMulti,
  label = __('Filter by group'),
  onChange,
  placeholder = __('Search and select groups'),
  value,
  ...otherReactSelectProps
}: ReactSelectTopicsProps) => (
  <ReactSelectAdaptive
    {...otherReactSelectProps}
    queryKey={['react-select', 'topics']}
    queryFn={getTopicsOptions}
    extractData={extractData}
    shouldUseAsync={shouldUseAsync}
    dataToOptions={topicsToOptions}
    isMulti={isMulti}
    label={label}
    placeholder={placeholder}
    onChange={onChange}
    value={value}
  />
);

export default ReactSelectTopics;
